import React, { useState } from 'react';
import { Button } from './ui/button';
import { Download, Loader2 } from 'lucide-react';

const getValueByPath = (obj, path) => {
  if (!obj || !path) return '';
  try {
    return path.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : ''), obj);
  } catch {
    return '';
  }
};

const ExportExcelButton = ({
  service,
  filters = {},
  columns,
  fileName = 'datos',
  dataMapper = (item) => item,
}) => {
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      // Carga perezosa de xlsx: ~700KB solo cuando se exporta.
      const XLSX = await import('xlsx');

      const response = await service({ query: filters, limit: 10000, offset: 1 });
      const dataToExport = response?.data || response;

      if (!Array.isArray(dataToExport)) {
        console.error('El servicio no retornó un arreglo de datos válido.');
        setLoading(false);
        return;
      }

      const mapped = dataToExport.map(dataMapper);
      const finalData = mapped.map((item) => {
        const row = {};
        columns.forEach((col) => {
          row[col.header] = getValueByPath(item, col.key);
        });
        return row;
      });

      const worksheet = XLSX.utils.json_to_sheet(finalData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Datos');
      XLSX.writeFile(workbook, `${fileName}.xlsx`);
    } catch (error) {
      console.error('Error al exportar a Excel:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      onClick={handleExport}
      disabled={loading}
      variant="outline"
      className="border-green-600 text-green-700 hover:bg-green-50 dark:text-green-400 dark:hover:bg-green-900/20"
    >
      {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Download className="mr-2 h-4 w-4" />}
      {loading ? 'Exportando…' : 'Exportar Excel'}
    </Button>
  );
};

export default ExportExcelButton;
